<form [formGroup]="form">
  <div class="detail-card-header mat-dialog-add-content">
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "hr.button.add.certificate" | translate }}
      </div>
    </span>
  </div>

  <mat-divider class="wh-dialog-divider"></mat-divider>
  <div class="mat-dialog-add-content">
    <div class="flex--c-fs gap--16">
      <div class="flex--row gap--16 w-100">
        <mat-form-field>
          <mat-label>{{ "hr.model.certificate.name" | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="qualification"
            [matAutocomplete]="auto"
          />
          <mat-icon
            matSuffix
            *ngIf="hasQualification()"
            (keydown.enter)="clear()"
            (click)="clear()"
            >close</mat-icon
          >
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayFn.bind(this)"
            (optionSelected)="onOptionClick($event)"
          >
            <mat-option
              *ngFor="let qualification of filteredOptions | async"
              [value]="qualification"
            >
              {{ qualification.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "hr.model.certificate.issuer" | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'hr.model.certificate.issuer' | translate }}"
            formControlName="issuer"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="flex--row gap--16">
        <mat-form-field>
          <mat-label>{{
            "hr.model.certificate.acquiredAt" | translate
          }}</mat-label>
          <input
            matInput
            [matDatepicker]="acquiredAt"
            formControlName="acquiredAt"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="acquiredAt"
          ></mat-datepicker-toggle>
          <mat-datepicker #acquiredAt></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{
            "hr.model.certificate.validDue" | translate
          }}</mat-label>
          <input
            matInput
            [min]="form.value.acquiredAt"
            [matDatepicker]="validDue"
            formControlName="validDue"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="validDue"
          ></mat-datepicker-toggle>
          <mat-datepicker #validDue></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="toggle-renewed">
        <div class="title">
          {{ "hr.model.certificate.renewed" | translate }}
        </div>
        <div class="default-value html-overflow p-b--8">
          {{ "hr.model.certificate.renewdescription" | translate }}
        </div>

        <mat-button-toggle-group
          style="width: fit-content"
          formControlName="renewed"
          aria-label="Renewed certificate"
          name="renewed"
          exclusive
        >
          <mat-button-toggle [value]="false">{{
            "app.no.label" | translate
          }}</mat-button-toggle>
          <mat-button-toggle [value]="true">{{
            "app.yes.label" | translate
          }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <w-h-button-group align="end">
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        type="stroked"
        (clicked)="cancel()"
      />
      <w-h-button
        [text]="'app.confirm.label' | translate | uppercase"
        color="accent"
        type="flat"
        [disabled]="formInvalid()"
        (clicked)="confirm()"
      />
    </w-h-button-group>
  </div>
</form>
